module.exports = __webpack_public_path__ + "static/img/nav3.91ae359.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/nav3.png
// module id = fVgY
// module chunks = 1